import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { I18NextService } from 'angular-i18next';
import { GlobalActions, RouteActions } from 'core';
import { RoutingConfig } from 'routing.config';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './access-denied.component.html',
    styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent {
    public title: string;
    public description: string;
    public buttonUrl: string = null;
    public buttonTitle: string = null;
    private blockedBPTypes: string[] = [/*'PS01', 'PS02', 'AA02', 'API01', 'API01V2',  */ 'CONF01', 'CONF01V2', 'GDS01', 'SP08', 'SP04'];

    constructor(private router: Router, private routeActions: RouteActions, private i18next: I18NextService) {
        GlobalActions.hideSpinner();
        this.buildData();
    }

    public buttonClick(): void {
        if (RouteActions.isExternalUrl(this.buttonUrl)) {
            this.routeActions.goToExternalUrl(this.buttonUrl);
        } else {
            this.router.navigate([this.buttonUrl]);
        }
    }

    // eslint-disable-next-line complexity
    private buildData(): void {
        const navigationState = this.router.getCurrentNavigation().extras.state;

        this.title = this.i18next.t(
            `shared:accessDeniedPage.${navigationState && navigationState.requestType ? navigationState.requestType : 'default'}.title`
        );

        const requestType = navigationState && navigationState.requestType;
        if (this.blockedBPTypes.some(x => x === requestType)) {
            this.description = this.i18next.t(
                `shared:accessDeniedPage.default.taisBlocked`
            );

        } else {
            this.description = navigationState && navigationState.description
                ? navigationState.description
                : null;
        }


        this.buttonTitle = navigationState && navigationState.buttonTitle
            ? navigationState.buttonTitle
            : this.i18next.t(`shared:accessDeniedPage.default.buttonTitle`);

        this.buttonUrl = navigationState && navigationState.buttonUrl
            ? navigationState.buttonUrl
            : RoutingConfig.RequestsList.Base;

    }
}
